export default __webpack_public_path__ + "static/media/bad_mood_face.984c091b.png";